import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "icon animate spin" }

import { svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-loading',
  props: {
    size: { default: "1.75rem" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "base-loading",
    style: _normalizeStyle({
      width: `calc(${__props.size} + 0.5rem)`,
      height: `calc(${__props.size} + 0.5rem)`,
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(svgIcon), {
        icon: "loading",
        size: __props.size
      }, null, 8, ["size"])
    ])
  ], 4))
}
}

})